import React from 'react';
import DeleteAccountModal from './delete_account_modal';
import DemoGuardedButton from '../../shared/demoGuardedButton';

export default class TeacherDangerZone extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showDeleteAccountModal: false,
    }
  }

  hideDeleteAccountModal = () => {
    this.setState({ showDeleteAccountModal: false, })
  };

  showDeleteAccountModal = () => {
    this.setState({ showDeleteAccountModal: true, })
  };

  renderModal() {
    if (this.state.showDeleteAccountModal) {
      return (
        <DeleteAccountModal
          cancel={this.hideDeleteAccountModal}
          deleteAccount={this.props.deleteAccount}
        />
      )
    }
  };

  render() {
    return (
      <section aria-labelledby="dangerZoneTitle" className="teacher-account-danger-zone user-account-section">
        {this.renderModal()}
        <h1 id="dangerZoneTitle">Danger Zone</h1>
        <section>
          <p className="danger-zone-description">This will delete your user account, including all classes and reports.</p>
          <DemoGuardedButton
            className="quill-button contained red small focus-on-light"
            onClick={this.showDeleteAccountModal}
          >
            Delete my account
          </DemoGuardedButton>
        </section>
      </section>
    )
  }
}
